"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getEditorialProducts = void 0;
var _productBox = require("@ori/product-box");
var _staticApiClientReact = require("@ori/static-api-client-react");
/* istanbul ignore file @preserve */ const getEditorialProducts = async (param)=>{
    let { fetchParams, isAnonymousUser, productCodes, staticApiClient, tenant } = param;
    const { data: { data } } = await (0, _staticApiClientReact.getTenantApplicationsProductBox)(staticApiClient, tenant, {
        ...fetchParams,
        productCodes
    });
    const { products } = data !== null && data !== void 0 ? data : {};
    if (!products) {
        return [];
    }
    return (0, _productBox.mapProductBoxesFromStaticApi)({
        data: products,
        mode: _productBox.ProductBoxMode.Product,
        isAnonymousUser
    });
};
exports.getEditorialProducts = getEditorialProducts;
